import { isArray } from "lodash";
import { MdDeleteOutline, MdModeEditOutline } from "react-icons/md";
import { Grid, Table } from "semantic-ui-react";

export const LoadTableData = ({
  chemicalData,
  chemicalDataType,
  updateChemicalData,
  deleteDataAction,
  lockStatus = false
}: any) => {
  return (
    <>
      {isArray(chemicalData)
        ? chemicalData?.map((data: any, index: any) => {
            const addedChemical = chemicalDataType?.find(
              (chemical: any) =>
                chemical.value == data?.commercialChemicalId?.chemicalMixture?.[0]?.chemicalType
            );
            return (
              <Table.Row className="tbleR" key={data._id || index}>
                <Table.Cell>
                  <p>{data?.commercialChemicalId?.chemicalName || "Name Not Available"}</p>
                </Table.Cell>
                <Table.Cell>
                  <p>{addedChemical?.text || ""}</p>
                </Table.Cell>
                <Table.Cell>
                  <p>{data?.amount}</p>
                </Table.Cell>
                {!lockStatus && (
                  <Table.Cell>
                    <Grid>
                      <Grid.Column
                        computer={8}
                        tablet={16}
                        mobile={16}
                        key={`${data._id}-edit`}
                        className="alignTableIcon"
                      >
                        <MdModeEditOutline
                          cursor={"pointer"}
                          onClick={() => {
                            updateChemicalData(data, chemicalDataType);
                          }}
                          size={24}
                          color="var(--tableEditIcon)"
                        />
                      </Grid.Column>
                      <Grid.Column
                        computer={8}
                        tablet={16}
                        mobile={16}
                        key={`${data._id}-delete`}
                        className="alignTableIcon"
                      >
                        <MdDeleteOutline
                          cursor={"pointer"}
                          size={24}
                          color="var(--tableEditIcon)"
                          onClick={() => {
                            deleteDataAction(data);
                          }}
                        />
                      </Grid.Column>
                    </Grid>
                  </Table.Cell>
                )}
              </Table.Row>
            );
          })
        : null}
    </>
  );
};

export const LoadTransportTableData = ({
  chemicalTransportData,
  TransportTypeList,
  updateChemicalTransportData,
  deleteDataTransportationAction,
  lockStatus = false
}: any) => {
  return (
    <>
      {isArray(chemicalTransportData)
        ? chemicalTransportData.map((data: any, index: any) => {
            const transportType = TransportTypeList?.find(
              (type: any) => type.value == data?.transportType
            );
            return (
              <Table.Row className="tbleR" key={data._id || index}>
                <Table.Cell>
                  <p>{transportType?.text || ""}</p>
                </Table.Cell>
                <Table.Cell>
                  <p>{data?.distance}</p>
                </Table.Cell>
                {!lockStatus && (
                  <Table.Cell>
                    <Grid>
                      <Grid.Column
                        computer={8}
                        tablet={16}
                        mobile={16}
                        key={`${data._id}-edit`}
                        className="alignTableIcon"
                      >
                        <MdModeEditOutline
                          cursor={"pointer"}
                          onClick={() => {
                            updateChemicalTransportData(data);
                          }}
                          size={24}
                          color="var(--tableEditIcon)"
                        />
                      </Grid.Column>
                      <Grid.Column
                        computer={8}
                        tablet={16}
                        mobile={16}
                        key={`${data._id}-delete`}
                        className="alignTableIcon"
                      >
                        <MdDeleteOutline
                          cursor={"pointer"}
                          size={24}
                          color="var(--tableEditIcon)"
                          onClick={() => {
                            deleteDataTransportationAction(data);
                          }}
                        />
                      </Grid.Column>
                    </Grid>
                  </Table.Cell>
                )}
              </Table.Row>
            );
          })
        : null}
    </>
  );
};
